export const build = { date:"2026-04-07.1445", stage:"alpha" }
